// extracted by mini-css-extract-plugin
export default {"description":"VideoDescription_description__0Eo-1"};